import { filterOptionsType } from "../../../enums/filterOptionsType"

export const filtersSelectsData = [
    {
        filterName: "myclass", itemField: "classrange", value: null, optionsType: filterOptionsType.fromJson, options: [
            { name: "elementaryClass1To3", value: ["1", "2", "3"] },
            { name: "elementaryClass4To6", value: ["4", "5", "6"] },
            { name: "middleSchoolClass", value: ["7", "8", "9"] },
            { name: "hightSchoolClass", value: ["10", "11", "12"] },
        ]
    },
    {
        filterName: "filterContentType", itemField: "filterContentType", value: null, optionsType: filterOptionsType.fromJson, options: [
            { name: "contentPresentation", value: "presentation" },
            { name: "contentTeachersKit", value: "teachersKit" },
            { name: "contentLessonPlans", value: "lessonPlans" },
            { name: "contentBestpractice", value: "bestpractice" },
            { name: "contentPhysicalGames", value: "physicalGames" },
            { name: "contentWebinar", value: "webinar" },
            { name: "contentCourse", value: "course" },
            { name: "contentPodcast", value: "podcast" },
            { name: "contentTeachersvid", value: "teachersvid" },
            { name: "learningEvents", value: "learningEvent" },
            { name: "stemActivity", value: "stemActivity" },
        ]
    },
    {
        filterName: "filterAIComp", itemField: "filterAIComp", minWidth: "224px", value: null, optionsType: filterOptionsType.fromJson, options: [
            { name: "AiEducation", value: "1" },
            { name: "STEMEducation", value: "2" },
        ]
    },
]
